<template>

    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Crear Usuario</p>
                <argon-button color="success" size="sm" class="ms-auto"  @click="save"
                  >Guardar</argon-button
                >
              </div>
            </div>
            <div class="card-body">
              <form autocomplete="off" @submit.prevent>
              <p class="text-uppercase text-sm">Información</p>
              <div class="row">
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Nombre</label
                  >
                  <argon-input type="text"  v-model="user.name"/>
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Teléfono</label
                  >
                  <argon-input type="text" v-model="user.phone"  autocomplete="off" />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Correo electrónico</label
                  >
                  <argon-input type="email" v-model="user.email" autocomplete="off"  />
                </div>

                 <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label">Dirección</label>
                    <argon-input type="text" v-model="user.address" autocomplete="off" />
                  </div>

                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Tipo de Documento</label
                  >
                  <select
                    id="user_document_type"
                    class="form-select"
                    v-model="user.document_type"
                    autocomplete="off"
                  >
                    <option value="">Seleccione un tipo</option>
                    <option value="CC">Cédula de Ciudadanía (CC)</option>
                    <option value="CE">Cédula de Extranjería (CE)</option>
                    <option value="TI">Tarjeta de Identidad (TI)</option>
                    <option value="RC">Registro Civil (RC)</option>
                    <option value="PA">Pasaporte (PA)</option>
                    <option value="PEP">Permiso Especial de Permanencia (PEP)</option>
                    <option value="NIT">Número de Identificación Tributaria (NIT)</option>
                  </select>
                </div>

                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Número de Documento</label
                  >
                  <argon-input
                    id="user_document"
                    name="user_document_number"
                    type="text"
                    v-model="user.document"
                    autocomplete="off"
                  />
                </div>

                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Contraseña</label
                  >
                  <argon-input type="password" v-model="user.password"  autocomplete="off" />
                </div>

                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Confirmar Contraseña</label
                  >
                  <argon-input type="password" v-model="user.password_confirmation" autocomplete="off"  />
                </div>
                

                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Forma de pago</label
                  >
                  <select id="user_payment" class="form-select" v-model="user.payment" autocomplete="off">
                    <option value="0">Mensualidad</option>
                    <option value="1">Por Tarea</option>
                  </select>
                </div>

                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Cargo</label
                  >
                  <select id="user_role" class="form-select" v-model="user.role" autocomplete="off">
                    <option value="1">Administrador</option>
                    <!-- <option value="2">Supervisor</option>
                    <option value="3">Operario</option> -->
                    <option value="4">Cliente</option>
                    <option value="5">Proveedor</option>
                    <option value="6">Operador</option>
                  </select>
                </div>

                <div class="col-md-12" hidden>
                  <label for="processes-checkbox-list" class="form-control-label">Procesos</label>
                  <div id="processes-checkbox-list" class="checkbox-grid">
                    <div v-for="process in processes" :key="process.id" >
                      <argon-checkbox 
                        :id="'process-' + process.id" 
                        :value="process.id" 
                        :checked="user.processes.includes(process.id)"
                        v-model="user.processes" 
                      >
                        {{ process.name }}
                      </argon-checkbox>
                    </div>

                  </div>
                </div>

                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Estado</label
                  >
                  <select id="user_status" class="form-select" v-model="user.status" autocomplete="off">
                    <option value="1">Activo</option>
                    <option value="0">Inactivo</option>
                  </select>
                </div>
               
              </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

</template>

<style scoped>
.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Dos columnas iguales */
}
</style>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import ArgonCheckbox from "../../../components/ArgonCheckbox.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';

const body = document.getElementsByTagName("body")[0];


export default {
  name: "User Create",
  data() {
    return {
      showMenu: false,
      user: {
        id:0,
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        role: '1',
        status: '1',
        phone: '',
        payment: '0',
        processes: [],
        address: '',
        document_type: '',
        document: ''
      },
      processes: [],
    };
  },
  components: { ArgonInput, ArgonButton, ArgonCheckbox },
  methods: {
    async getOficios() {
      this.processes =  await this.$store.dispatch('users/getOficios'); 
    },
    formatSaveError(response) {
      const d = response?.data;
      if (!d) return 'No se pudo guardar el usuario.';
      if (typeof d.message === 'string' && d.message.trim()) return d.message.trim();
      if (d.errors && typeof d.errors === 'object') {
        const parts = Object.values(d.errors).flat().filter(Boolean);
        if (parts.length) return parts.join(' ');
      }
      return 'No se pudo guardar el usuario.';
    },
    async save() {
      try {
        const response = await this.$store.dispatch("users/save", this.user);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El usuario ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
              if (result.isConfirmed) {
                    this.$router.push({ name: 'Users' });
              }
          });
        } else {
          const msg = this.formatSaveError(response);
          await Swal.fire({
            icon: 'error',
            title: 'No se pudo guardar',
            text: msg,
          });
        }
      } catch (error) {
        console.error("Error al crear el usuario:", error);
        const text = error.response
          ? this.formatSaveError(error.response)
          : (error.message || 'Error al guardar el usuario');
        await Swal.fire({
            icon: 'error',
            title: 'No se pudo guardar',
            text,
        });
      }
    }
  },
  mounted() {

    this.getOficios();

    const route = useRoute();
    const data = route.params.user;

    this.$nextTick(() => {
      $(this.$refs.processesSelect).select2();
      
      $(this.$refs.processesSelect).on('change', (event) => {
        this.user.processes = JSON.stringify($(event.target).val());
      });
    });

    if (data) {
        try {
            const params = JSON.parse(data); // Asegúrate de que este JSON se pueda parsear

            // Verifica si params contiene los datos de user
            if (params && params.id) {
                // Llena los campos del formulario con los datos del usuario
                this.user.id = params.id || 0;
                this.user.name = params.name || '';
                this.user.email = params.email || '';
                this.user.role = params.role || '1'; 
                this.user.status = params.status || '1'; 
                this.user.phone = params.phone || ''; 
                this.user.payment = params.payment || '';
                this.user.address = params.address || '';
                this.user.document_type = params.document_type || '';
                this.user.document = params.document || '';
                
                this.user.processes = JSON.parse(params.processes) || []; 
                $(this.$refs.processesSelect).val(this.user.processes).trigger('change');
            }
        } catch (error) {
            console.error("Error al parsear los datos del usuario:", error);
        }
    }

    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>
